import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { SignupDetails } from "../../components/authentication/signup-details";

const Signup: React.FC = () => {
  const theme = useTheme();
 
  return (
    <Box
      sx={{
        paddingTop: 2,
      }}
    >
      <Stack
        direction={"column"}
        justifyContent={"space-between"}
        sx={{ margin: 2, gap: 2 }}
      >
        <Box sx={{ width: "80%", mx: "auto" }}>
          <Typography
            color="black"
            variant="h3"
            sx={{
              fontWeight: 500,
              letterSpacing: "-0.23999999463558197px",
            }}
          >
            Get Started
          </Typography>
          <Typography
            variant="body1"
            sx={{ color: theme.palette.secondary.contrastText }}
          >
            Create an account or log in.
          </Typography>
        </Box>

        <SignupDetails />
        <Typography
          variant="caption"
          sx={{
            color: theme.palette.secondary.contrastText,
            textAlign: "center",
            mt: 2,
            width: "80%",
            mx: "auto",
          }}
        >
          By registering you agree to our Terms & Conditions, Privacy Notice,
          and EULA
        </Typography>
      </Stack>
    </Box>
  );
};

export default Signup;
